import { FC, useRef } from "react";
import { useGetSpecs } from "../../../services/spec/spec.service";
import Table from "../../../components/Table/Table";
import { AgGridReact } from "ag-grid-react";
import Button from "../../../components/Button/Button";
import { Spec } from "../../../services/spec/spec.types";
import { ChangeOptionRecipeRawProductsStep } from "./ChangeOptionRecipeRawProducts";
import { RowSelectedEvent } from "ag-grid-community";
import { Variant } from "../../../components/Button/Button.types";
import { ButtonRow } from "./ChangeRawProducts.styles";

interface ChangeOptionRecipeRawProductsSelectSpecsProps {
  setSelectedSpecs: (specs: Spec[]) => void;
  setStep: (step: ChangeOptionRecipeRawProductsStep) => void;
}

const SelectSpecs: FC<ChangeOptionRecipeRawProductsSelectSpecsProps> = (
    {
      setSelectedSpecs,
      setStep
    }
) => {
  const gridRef = useRef<AgGridReact>();

  const { data: getSpecsResponse } = useGetSpecs({ isSubRecipe: true })
  const specs: Spec[] = getSpecsResponse?.data || [];

  const selectSpecs = (
      event: RowSelectedEvent
  ) => {
    setSelectedSpecs(event.api.getSelectedRows());
  };

  return (
      <>
        <Table
            ref={gridRef}
            showHeader={true}
            headerTitle="Available Specs"
            rowData={specs}
            returnedRecords={specs.length}
            rowSelection="multiple"
            onRowSelected={selectSpecs}
            columnDefs={[
              {
                width: 70,
                headerName: 'Select',
                checkboxSelection: true,
                floatingFilter: false,
                sortable: false
              },
              { minWidth: 150, flex: 1, field: 'specNo', headerName: 'Spec Number' },
              { minWidth: 300, flex: 3, field: 'description', headerName: 'Description' }
            ]}
        />
        <ButtonRow>
          <Button
              label={'Next'}
              onClick={() => setStep(ChangeOptionRecipeRawProductsStep.ConfirmChanges)}
              disabled={specs.length === 0}
          />
          <Button
              label={'Back'}
              variant={Variant.Secondary}
              onClick={() => setStep(ChangeOptionRecipeRawProductsStep.SelectRawProducts)}
          />
        </ButtonRow>
      </>
  )
}

export default SelectSpecs;